import React, { useState } from 'react';
import { RiArrowRightUpLine } from 'react-icons/ri';
import {
  BenefitsBackground,
  BenefitsContainer,
  Heading,
  SeeOpenRoles,
  Curve
} from './styled';
import BenefitDescription from './components/BenefitDescription';
import BenefitsGrid from './components/BenefitsGrid';
import Feathers from './components/Feathers';
import { BENEFITS } from './consts';

const Benefits = () => {
  const [selectedBenefit, setSelectedBenefit] = useState(6);

  const goToOpenRoles = () => {
    window.open('https://safetywing.pinpointhq.com', '_blank');
  };

  return (
    <>
      <BenefitsBackground>
        <BenefitsContainer>
          <Heading>Perks & benefits</Heading>

          <BenefitsGrid
            benefits={BENEFITS}
            selectedBenefit={selectedBenefit}
            setSelectedBenefit={setSelectedBenefit}
          />
          <BenefitDescription benefits={BENEFITS} selectedBenefit={selectedBenefit} />

          <SeeOpenRoles onClick={goToOpenRoles}>
            <span>See open roles</span>
            <RiArrowRightUpLine size={22} />
          </SeeOpenRoles>

          <Feathers />
        </BenefitsContainer>
      </BenefitsBackground>
      <Curve />
    </>
  );
};

export default Benefits;
